<template>
  <div class="row no-gutters body">    
    <div class="col-12 pb-5 mb-4" v-if="pageloader">
      <img src="../assets/pageloader.svg" class="pageloader" alt="loadinganimation">
    </div>
    <div class="col-12" v-if="!pageloader">
      <div class="row no-gutters">
        <div class="col-lg-3 middle-background"></div>
        <div class="col-md-12 col-lg-6 middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <!-- default profile id component if user didn't create their profile and trying to access home feed -->
          <div class="row no-gutters mt-5" v-if="!currentUserProfileId && currentUserProfileId === undefined">
            <div class="col-lg-12 pb-3">
              <div class="row no-gutters">
                <br />
              </div>
              <div class="ml-3 mr-3 mt-lg-2 main-card">
                <no-profile-id-component></no-profile-id-component>
              </div>
            </div>
          </div>
          <div class="row no-gutters mt-5" v-else>
            <div class="col-lg-11 ml-3 mt-5 mr-3" v-if="homeVideos.length < 1">
              <no-records-found :message="noRecordsFoundMessage"></no-records-found>
            </div>
            <div class="col-lg-12 pb-3" v-else>
              <div class="row no-gutters">
                <br />
              </div>
              <div class="more-button">
                <b-button v-if="showMoreVideos" @click="getVideosAfter()" class="mb-2 more-video backgroundcolorblack white">New Posts</b-button>
              </div>
              <!-- list of home videos -->
              <div v-for="(video,index) in homeVideos" :key="index" class="main-card">
                <!-- if video is a posted video -->
                <div class="shadow card mb-2 ml-3 mr-3 mt-lg-2" v-if="video.videoType === 'POST'">
                  <div class="card-body homevideoslist" :id="'videoCardItem'+index">
                    <div class="d-flex flex-column">                      
                      <div class="videocardhead d-flex justify-content-between p-3">
                        <div class="d-flex" v-if="video.userDetailsVo">
                          <div class="pl-1">
                            <!-- <img v-if="!video.userDetailsVo.profilePictureLink" oncontextmenu="return false;" @click="selectedUser(video.userDetailsVo.userId)" class="img-fluid postvideoimage"  src="../assets/Profile_placehlder.svg" /> -->
                            <div v-if="!video.userDetailsVo.profilePictureLink" id="profImage" class="othercircles text-center pointer rounded-circle white" :class="video.userDetailsVo.userFirstName.charAt(0)" oncontextmenu="return false;" @click="selectedUser(video.userDetailsVo.aliasLink)">
                                <span class="white fontsize16 text-uppercase">{{video.userDetailsVo.userFirstName.charAt(0)}}</span>
                            </div>
                            <img v-else :src="video.userDetailsVo.profilePictureLink" @error="profilePictureFailure(video, 'original')" oncontextmenu="return false;" @click="selectedUser(video.userDetailsVo.aliasLink)" alt="profilepic" class="rounded-circle border border-secondary postvideoimage loadingBgImg" width="40px">
                          </div>
                          <div class="d-flex flex-column pl-2 pr-2 mt-0 text-capitalize">
                            <span class="fontsize14 proximanova-semibold black nameBlock" @click="selectedUser(video.userDetailsVo.aliasLink)" v-if="video.userDetailsVo.userFirstName">{{video.userDetailsVo.userFirstName}} {{video.userDetailsVo.userLastname}}</span>
                            <span class="proximanova black80 fontsize12" v-if="video.userDetailsVo.designation">{{video.userDetailsVo.designation}} <span class="proximanova black80 fontsize12" v-if="video.userDetailsVo.cityName">-{{video.userDetailsVo.cityName}} </span>  <span v-if="video.creationD !== null && video.lastUpdatedD == null">, {{new Date(video.creationD) | moment("from", "now", true)}} ago</span><span v-else>, {{new Date(video.lastUpdatedD) | moment("from", "now", true)}} ago</span> </span>                   
                          </div>
                          <!-- <div class="proximanova black80 fontsize12 pt-1 ml-3">
                            <span v-if="video.creationD !== null && video.lastUpdatedD == null">{{new Date(video.creationD) | moment("from", "now", true)}} ago</span>
                            <span v-else>{{new Date(video.lastUpdatedD) | moment("from", "now", true)}} ago</span>
                          </div> -->
                        </div>
                        <div class="d-flex">
                          <div >
                            <div>
                              <button class="fontsize14 bordernone backgroundnone proximanova-semibold black mr-lg-3 p-1" :disabled="video.disablefollowBtn" id= "follow" v-if="video.followVideoFlag === 'Y' && currentUser.profileId !== video.profileId" @click="UnfollowUser(video.profileId,video)" >UnFollow</button>
                              <button class="fontsize14 bordernone backgroundnone proximanova-semibold black mr-lg-3 p-1" :disabled="video.disablefollowBtn" id= "follow" v-if="video.followVideoFlag === 'N' && currentUser.profileId !== video.profileId" @click="follow(video.profileId,video)" >Follow</button>                          
                            </div>
                          </div>
                          <div>
                            <img src="../assets/More_Actions.svg" v-if="currentUser.profileId !== video.profileId" :id="video.moremenuname" width="20px" alt="moremenu" v-popover = "{name: 'popover'+index}" class="menuicon moreactionsmenu">
                            <popover v-bind:name="'popover'+index" class="postvideomenu" id="postvideomenu">
                                <div class="p-2">
                                    <div class="d-flex p-1 justify-content-between">
                                      <span class="fontsize12 proximanova-bold black">More Actions</span>
                                      <div class="closebtnmouseover">
                                        <img src="../assets/Close1.svg" alt="close" class="img-fluid pr-1 closebtn" @click="close(video,index)">
                                      </div>
                                    </div>
                                    <div class="d-flex p-2 action" @click="openHideConfirmationmodal(video,index)">
                                        <img src="../assets/Hide.svg" alt="hide" class="img-fluid pl-1 pr-1 ">
                                        <span class="pt-1 pl-2 d-flex flex-column">
                                          <div class="fontsize14 black80 proximanova">Hide</div>
                                          <div class="fontsize12 black60 proximanova">Not intrested to see this post</div> 
                                        </span>
                                    </div>
                                    <div class="d-flex p-1 action" @click="getReportmessage(video, index)">
                                        <img src="../assets/Report.svg" alt="report" class="img-fluid pl-1 pr-1 ">
                                        <span class="pt-1 pl-2 d-flex flex-column">
                                          <div class="fontsize14 black80 proximanova">Report</div>
                                          <div class="fontsize12 black60 proximanova">This post is not relevent or offensive</div>
                                        </span>
                                    </div>                                  
                                    <!-- <div class="d-flex p-1 action" >
                                        <img src="../assets/TurnOff.svg" alt="turnoff" class="img-fluid pl-1 pr-1">
                                        <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                          <div class="fontsize14 black80 proximanova">Turn Off</div>
                                          <div class="fontsize12 black60 proximanova">Stop receiving posts like this</div>
                                        </span>
                                    </div> -->
                                </div>
                              </popover>   
                            </div>                     
                        </div>
                      </div>
                      <div class="videocardbody">
                        <div class="">
                          <!-- <div class="mt-3" >                            
                          </div> -->
                        </div>
                        <div class="overlay1"></div>
                        <!-- <span v-if="video.aspectRatio" >
                          <span v-if="video.aspectRatio < 1">
                            <video controlsList="nodownload" :src="video.videoLink" controls muted  oncontextmenu="return false;" class="postedvideoItem portraitvideheight" @loadedmetadata="videoMetaLoaded(index,video.id)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)" @error ="videoLoading(video.id,index)" :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                            </video>
                          </span>
                          <span v-if="video.aspectRatio > 1">
                            <video controlsList="nodownload" controls muted :src="video.videoLink" oncontextmenu="return false;" class="postedvideoItem" @loadedmetadata="videoMetaLoaded(index,video.id)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)" @error ="videoLoading(video.id,index)" :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                            </video>
                          </span>
                          <span v-if="video.aspectRatio = 1">
                            <video controlsList="nodownload" controls muted :src="video.videoLink" oncontextmenu="return false;" class="postedvideoItem" :class="{'portraitvideheight' : video.videoHeight > video.videoWidth}" @loadedmetadata="videoMetaLoaded(index,video.id)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)" @error ="videoLoading(video.id,index)" :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                            </video>
                          </span>
                        </span>
                        <span v-else> -->
                          <video controlsList="nodownload" height="430px" :src="video.videoLink" oncontextmenu="return false;" controls muted  class="postedvideoItem" @loadedmetadata="videoMetaLoaded(index,video.id)"  @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)" @error ="videoLoading(video.id,index)" :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                            <!-- <source :src="video.videoLink"> -->
                          </video>
                        <!-- </span>                         -->
                      </div>     
                      <div class="postvideocontent p-1 pb-2 pl-3 d-flex justify-content-between">
                        <div class="d-flex flex-column pl-2 descript-section">
                          <span class="proximanova-bold fontsize16 black80 text-capitalize">{{video.videoTitle}}</span>                                                    
                        </div>
                        <div class="hover" v-if="currentUser.profileId !== video.profileId">
                          <span v-if="video.savedVideoFlag === 'Y'" @click="unSaveVideo(video.id, video.profileId, index)">
                            <img src="../assets/saveblue.svg" width="20px" alt="save" class="p-1">
                            <span class="fontsize12 proximanova-bold blue mr-3">Saved</span>
                          </span>
                          <span v-else @click="saveVideo(video.id, video.profileId, index)">
                            <img src="../assets/save.svg" width="20px" alt="save" class="p-1">
                            <span class="fontsize12 proximanova-bold black mr-3">Save</span>
                          </span>                          
                        </div>
                      </div> 
                      <div class="d-flex flex-column pl-3 pr-3">
                        <span class="proximanova fontsize14 flex-wrap black60 ml-2" v-if="video.description1">{{video.videoDescription}}
                          <span @click="readmore(index)" v-if="video.videoDescription.length > 299"><span v-if="!video.readmoreclicked" class="fontsize14 blue pointer">...readmore</span></span><span class="fontsize14 blue pointer" v-if="video.readmoreclicked" @click="readless(index)">...readless</span>
                          </span>
                          <span class="proximanova fontsize14 blue ml-2 mb-2" v-if="video.hashTagList && video.hashTagList.length > 0">{{video.hashTagList[0].hashTag.tagText}}</span>
                      </div>
                      <div class="horizonline"></div> 
                      <div class="d-flex p-3 ">
                        <div class="d-flex ml-2 ">
                          <img src="../assets/Like.svg" alt="like" class="postvideoIcons" v-if="video.likeVideoFlag === 'N'" @click="likeVideo(video.id, video.profileId)">
                          <img src="../assets/Likedblue.svg"  alt="like" class="postvideoIcons" v-if="video.likeVideoFlag === 'Y'" @click="unlikeVideo(video.id, video.profileId)">
                          <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="video.noOfLikes>0"><span v-if="video.noOfLikes<10">0</span>{{video.noOfLikes}} </span>
                          <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                        </div>
                        <div class="d-flex ml-lg-5 ml-4">
                          <img src="../assets/Comment.svg" alt="comment" v-if="video.commentVideoFlag == 'N'" class="postvideoIcons">
                          <img src="../assets/Commentblue.svg" alt="comment" v-if="video.commentVideoFlag == 'Y'" class="postvideoIcons">
                          <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="video.noOfComments>0">{{video.noOfComments}}</span>
                          <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                        </div>
                        <div class="d-flex ml-lg-5 ml-4">
                          <img src="../assets/Share_Video.svg" alt="share" class="postvideoIcons"  @click="ShareVideoModal(video, 'posted','create')">
                          <span class="profiledetails fontsize12 proximanova d-none d-md-block  black60 pt-1 ml-2 share-text">Share</span>
                        </div>
                        
                        <div class="d-flex ml-lg-5 ml-4">
                          <img src="../assets/Views.svg" alt="views" class="postvideoIcons">
                          <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="video.noOfViews>0">{{video.noOfViews}}</span>
                          <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                        </div>
                      </div>  
                      
                      <div class="horizonline1"></div>
                      <div class="card-footer">    
                        <div class="commentsection d-flex pt-3 pl-3 pr-3 pb-1 comment-background">
                          <div class="pl-2">
                            <!-- <img v-if="!currentUserProfilePic" oncontextmenu="return false;" src="../assets/Profile_placehlder.svg" alt="" class="rounded-circle" width="38px"> -->
                            <div v-if="!currentUserProfilePic" id="profImage" class="othercircles text-center pointer rounded-circle white" :class="currentUser.firstName.charAt(0)" oncontextmenu="return false;">
                                <span class="white fontsize16 defpaddingtop text-uppercase">{{currentUser.firstName.charAt(0)}}</span>
                            </div>
                            <img v-else :src="currentUserProfilePic" oncontextmenu="return false;" alt="profilepic" class="rounded-circle  loadingBgImg" width="38px">
                          </div>
                          <div class="commentssection d-flex ">
                            <input type="text" v-model="video.comment" class="commentssectiontext proximanova black60" placeholder="Add my comment..." @keyup="video.postcommentbtn = true">
                            <img src="../assets/commentsend.svg" width="30px" v-if="video.postcommentbtn" height="25px" title="post comment"  class="postcommenticon ml-1" alt="comment" @click="PostComment(video.id, video.profileId,video.comment)">
                          </div>                        
                        </div>    
                        <div v-if="video.listOfComments">
                          <div class="pb-3 ">
                            <div v-if="video.listOfComments.length>0">
                              <div v-for="(comment,cmind) in video.listOfComments" :key="cmind" class="comment-background">
                                <div class="d-flex pt-3 pl-3 pr-3" v-if="cmind < video.limit_by">
                                  <div class="pl-2">
                                    <!-- <img v-if="!comment.profilePictureLink" oncontextmenu="return false;" src="../assets/Profile_placehlder.svg" alt="" class="rounded-circle" width="38px"> -->
                                    <div v-if="!comment.profilePictureLink" id="profImage" class=" text-center pointer rounded-circle white" :class="comment.firstName.charAt(0)" oncontextmenu="return false;">
                                      <p class="white fontsize16 defpaddingtop text-uppercase">{{comment.firstName.charAt(0)}}</p>
                                    </div>
                                    <img v-else :src="comment.profilePictureLink" @error="comment.profilePictureLink = null" alt="profilepic" oncontextmenu="return false;" class="rounded-circle loadingBgImg" width="38px">
                                  </div>
                                  <div v-if="currentUser.profileId !== comment.profileId" class="commentssectiontext2 pl-3 p-2">
                                    <div class="d-flex flex-column">
                                      <span class="fontsize12 proximanova-semibold black">{{comment.firstName}} {{comment.lastName}}</span>
                                      <span class="proximanova black80 fontsize12" v-if="comment.designationName">{{comment.designationName}}<span class="proximanova black80 fontsize12" v-if="comment.country">, {{comment.country}}</span></span>
                                    </div>
                                    <span class="proximanova black60  fontsize14">{{comment.comment}}</span>
                                  </div>
                                  <div v-else class="commentssectiontext2 pl-3 p-2">
                                    <div class="d-flex justify-content-between">
                                      <div class="d-flex flex-column">
                                        <span class="fontsize12 proximanova-semibold black">{{comment.firstName}} {{comment.lastName}}</span>
                                        <span class="proximanova black80 fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                                      </div>
                                      <div>
                                        <img src="../assets/commentsend.svg" width="28px" height="22px" class="postcommenticon mr-2" v-if="comment.iscommentchanged" title="update comment" alt="comment" @click="Update(comment.commentId,video.id, video.profileId,comment)">
                                        <img src="../assets/Delete_Comment.svg" width="28px" height="22px" class="postcommenticon mt-2 mr-2" title="delete comment" alt="deletecomment" @click="openDeleteCommentConfirmationmodal(cmind, comment, video)">
                                      </div>
                                    </div>
                                    <input type="text" class="commentssectiontext3 proximanova black60  fontsize14" v-model="comment.comment"  @keyup="DisplayPostCommentUpdate(comment)">
                                  </div>                                
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="viewallcomments pl-5 pb-3" >
                            <span class="pl-4 ml-3 proximanova black fontsize12" v-if="video.noOfComments > 0 && video.noOfComments > video.limit_by"  @click="showAllComments(video.id)">View all Comments</span>
                            <span class="pl-4 ml-3 proximanova black fontsize12" v-if="video.limit_by > 0 && video.noOfComments <= video.limit_by"  @click="viewLessComments(video.id)">View less Comments</span>
                          </div>
                        </div> 
                      </div>                     
                    </div>                    
                  </div>                  
                </div>
                <!-- if video is a shared video -->
                <div class="shadow card mb-2 ml-3 mr-3 mt-lg-2 d-flex justify-content-center" v-if="video.videoType === 'SHARE'">
                  <div class="card-body homevideoslist">
                      <div class="d-flex flex-column">
                        <div class="videocardhead d-flex justify-content-between p-3">
                          <div class="d-flex" v-if="video.sharedVideoUserDetails">
                            <div class="pl-1">
                              <!-- <img v-if="!video.sharedVideoUserDetails.profilePictureLink" oncontextmenu="return false;"  @click="selectedUser(video.sharedVideoUserDetails.userId)" class="img-fluid postvideoimage"  src="../assets/Profile_placehlder.svg" /> -->
                              <div v-if="!video.sharedVideoUserDetails.profilePictureLink" id="profImage" class=" text-center pointer rounded-circle white" :class="video.sharedVideoUserDetails.userFirstName.charAt(0)" @click="selectedUser(video.sharedVideoUserDetails.userId)" oncontextmenu="return false;">
                                <p class="white fontsize16 defpaddingtop text-uppercase">{{video.sharedVideoUserDetails.userFirstName.charAt(0)}}</p>
                              </div>
                              <img v-else :src="video.sharedVideoUserDetails.profilePictureLink"  @error="profilePictureFailure(video, 'shared')" oncontextmenu="return false;" @click="selectedUser(video.sharedVideoUserDetails.aliasLink)" alt="profilepic" class="rounded-circle border border-secondary postvideoimage loadingBgImg" width="40px">
                            </div>
                            <div class="d-flex flex-column pl-2 pr-2 mt-0 text-capitalize">
                              <span class="fontsize14 proximanova-semibold black nameBlock" v-if="video.sharedVideoUserDetails.userFirstName" @click="selectedUser(video.sharedVideoUserDetails.aliasLink)">{{video.sharedVideoUserDetails.userFirstName}} {{video.sharedVideoUserDetails.userLastname}}</span>
                              <span class="proximanova black80 fontsize12" v-if="video.sharedVideoUserDetails.designation">{{video.sharedVideoUserDetails.designation}}<span class="proximanova black80 fontsize12" v-if="video.sharedVideoUserDetails.cityName">-{{video.sharedVideoUserDetails.cityName}} </span>  <span v-if="video.creationD !== null && video.lastUpdatedD == null"> , {{new Date(video.creationD) | moment("from", "now", true)}} ago</span><span v-else> , {{new Date(video.lastUpdatedD) | moment("from", "now", true)}} ago</span>  </span>
                              <!-- <span v-if="video.creationD !== null && video.lastUpdatedD == null">{{new Date(video.creationD) | moment("from", "now", true)}} ago</span>
                              <span v-else>{{new Date(video.lastUpdatedD) | moment("from", "now", true)}} ago</span> -->
                            </div>
                            <!-- <div class="proximanova black80 fontsize12 pt-1 ml-3">
                              <span v-if="video.creationD !== null && video.lastUpdatedD == null">{{new Date(video.creationD) | moment("from", "now", true)}} ago</span>
                              <span v-else>{{new Date(video.lastUpdatedD) | moment("from", "now", true)}} ago</span>
                            </div> -->
                          </div>
                          <div class="d-flex">
                            <div >
                              <button class="bordernone backgroundnone fontsize14 proximanova-semibold black mr-lg-3 p-1" id="follow" :disabled="video.disablefollowBtn" v-if="video.followVideoFlag === 'Y' && currentUser.profileId !== video.profileId" @click="UnfollowUser(video.profileId,video)" >UnFollow</button>
                              <button class="bordernone backgroundnone fontsize14 proximanova-semibold black  mr-lg-3 p-1" id="follow" :disabled="video.disablefollowBtn" v-if="video.followVideoFlag === 'N' && currentUser.profileId !== video.profileId" @click="follow(video.profileId,video)" >Follow</button>                          
                            </div>
                            <div>
                              <img src="../assets/More_Actions.svg" width="20px" :id="video.moremenuname" alt="moremenu"  v-popover = "{name: video.moremenuname}" class="menuicon moreactionsmenu">
                              <popover v-bind:name="video.moremenuname" class="postvideomenu" id="postvideomenu">
                                <div class="p-2">
                                    <div class="d-flex p-1 justify-content-between"> 
                                      <span class="fontsize12 proximanova-bold black">More Actions</span>
                                      <div class="closebtnmouseover">
                                        <img src="../assets/Close1.svg" alt="close" class="img-fluid pr-1 closebtn" @click="close(video,index)">
                                      </div>
                                    </div>
                                    <div class="d-flex p-1 action" @click="ShareVideoModal(video, 'shared','edit')" v-if="currentUser.profileId === video.profileId">
                                        <img src="../assets/Edit_Share.svg" alt="editshare" class="img-fluid pl-1 pr-1 ">
                                        <span class="pt-1 pl-2 d-flex flex-column">
                                          <div class="fontsize14 black80 proximanova">Edit</div>
                                          <div class="fontsize12 black60 proximanova">Edit your statement about this post</div> 
                                        </span>
                                    </div>
                                    <div class="d-flex p-1 action" @click="DeletePostedVideo(video,index)" v-if="currentUser.profileId === video.profileId">
                                        <img src="../assets/Delete_all.svg" alt="delete" class="img-fluid pl-1 pr-1 ">
                                        <span class="pt-1 pl-2 d-flex flex-column">
                                          <div class="fontsize14 black80 proximanova">Delete</div>
                                          <div class="fontsize12 black60 proximanova">Remove from your timeline</div>
                                        </span>
                                    </div>
                                    <div class="d-flex p-1 action" v-if="currentUser.profileId === video.profileId">
                                        <img src="../assets/Privacy_Share.svg" alt="privacy" class="img-fluid pl-1 pr-1">
                                        <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                          <div class="fontsize14 black80 proximanova">Privacy</div>
                                          <div class="fontsize12 black60 proximanova">Keep your post privacy</div>                                        
                                        </span>
                                    </div>
                                    <div class="row ml-3 p-2  proximanova black80 fontsize12" v-if="currentUser.profileId === video.profileId">
                                      <form>
                                        <div class="form-check pb-2">
                                          <label class="form-check-label" for="radio1">
                                            <input type="radio" class="form-check-input" id="radio1" name="optradio" value="PUBLIC" @change="onChange($event,video,'PUBLIC')"  >
                                            <span>Public</span>
                                          </label>
                                        </div>
                                        <div class="form-check pb-2">
                                          <label class="form-check-label" for="radio2">
                                            <input type="radio" class="form-check-input" id="radio2" name="optradio" value="FOLLOWER" @change="onChange($event,video,'FOLLOWER')">
                                            <span>Followers</span>
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <label class="form-check-label" for="radio3">
                                            <input type="radio" class="form-check-input" id="radio3" name="optradio" value="PRIVATE" @change="onChange($event,video,'PRIVATE')" >
                                            <span>No one</span>
                                          </label>
                                          </div>                                            
                                        </form>                                          
                                      </div>
                                    </div>
                                    <div class="d-flex p-2 action" @click="openHideConfirmationmodal(video,index)"  v-if="currentUser.profileId !== video.profileId">
                                        <img src="../assets/Hide.svg" alt="hide" class="img-fluid pl-1 pr-1 ">
                                        <span class="pt-1 pl-2 d-flex flex-column">
                                          <div class="fontsize14 black80 proximanova">Hide</div>
                                          <div class="fontsize12 black60 proximanova">Not intrested to see this post</div> 
                                        </span>
                                    </div>
                                    <div class="d-flex p-1 action" @click="getReportmessage(video, index)" v-if="currentUser.profileId !== video.profileId">
                                        <img src="../assets/Report.svg" alt="report" class="img-fluid pl-1 pr-1 ">
                                        <span class="pt-1 pl-2 d-flex flex-column">
                                          <div class="fontsize14 black80 proximanova">Report</div>
                                          <div class="fontsize12 black60 proximanova">This post is not relevent or offensive</div>
                                        </span>
                                    </div>                                                                  
                                    <!-- <div class="d-flex p-1 action" v-if="currentUser.profileId !== video.profileId">
                                        <img src="../assets/TurnOff.svg" alt="turnoff" class="img-fluid pl-1 pr-1">
                                        <span class="pt-1 pl-1 d-flex flex-column ml-1">
                                          <div class="fontsize14 black80 proximanova">Turn Off</div>
                                          <div class="fontsize12 black60 proximanova">Stop receiving posts like this</div>
                                        </span>
                                    </div> -->
                              </popover>   
                            </div>
                          </div>
                        </div>
                        <div class="ml-5 pl-3 pb-2 description-text">
                           <!-- <span class="proximanova-semibold fontsize16 black80 flex-wrap">{{video.videoDescription}}{{video.videoDescription.length}}</span>      -->
                          <span class="proximanova fontsize14 flex-wrap text-capitalize black60" v-if="video.description1">{{video.videoDescription}}</span>
                          <span @click="readmore(index)" v-if="video.videoDescription && video.videoDescription.length > 299"><span v-if="!video.readmoreclicked" class="proximanova fontsize14 fontsize14 blue pointer">...readmore</span></span><span class="proximanova fontsize14 fontsize14 blue pointer" v-if="video.readmoreclicked" @click="readless(index)">...readless</span>                  
                        </div>
                        <div class="card mb-2 ml-4 mr-4 mt-lg-2">      
                          <div class="card-body homevideoslist">
                            <div class="d-flex flex-column">
                              <div class="videocardhead d-flex justify-content-between p-3">     
                                <div class="d-flex">                                  
                                  <div class="pl-1" v-if="video.userDetailsVo">                                    
                                    <!-- <img v-if="!video.userDetailsVo.profilePictureLink" oncontextmenu="return false;" @click="selectedUser(video.userDetailsVo.userId)"  class="img-fluid postvideoimage"  src="../assets/Profile_placehlder.svg" /> -->
                                    <div v-if="!video.userDetailsVo.profilePictureLink" id="profImage" class=" text-center pointer rounded-circle white" :class="video.userDetailsVo.userFirstName.charAt(0)" @click="selectedUser(video.userDetailsVo.aliasLink)" oncontextmenu="return false;">
                                      <p class="white fontsize16 defpaddingtop text-uppercase">{{video.userDetailsVo.userFirstName.charAt(0)}}</p>
                                    </div>
                                    <img v-else :src="video.userDetailsVo.profilePictureLink"  @error="profilePictureFailure(video, 'original')" oncontextmenu="return false;" @click="selectedUser(video.userDetailsVo.aliasLink)" alt="profilepic" class="rounded-circle border border-secondary postvideoimage loadingBgImg" width="40px">
                                  </div>
                                  <div class="d-flex flex-column pl-2 pr-2 mt-0 text-capitalize" v-if="video.userDetailsVo">
                                    <span class="fontsize14 proximanova-semibold black nameBlock" v-if="video.userDetailsVo.userFirstName" @click="selectedUser(video.userDetailsVo.aliasLink)">{{video.userDetailsVo.userFirstName}} {{video.userDetailsVo.userLastname}}</span>
                                    <span class="proximanova black80 fontsize12" v-if="video.userDetailsVo.designation">{{video.userDetailsVo.designation}}-{{video.userDetailsVo.cityName}}</span>
                                  </div>
                                </div>
                              </div>
                              <div class="videocardbody">
                                <div  class="">
                                  <!-- <div class="mt-3"> -->
                                    <!-- <img src="../assets/play_video.svg" class="playpostvideo" v-if="!video.isPlaying"  alt="" @click="play('video'+video.id,index,video.id, video.profileId,video.viewVideoFlag)" >
                                    <img src="../assets/Pausevideo.svg" class="pausebtn1 pausepostvideo" v-if="video.isPlaying" alt=""  > -->
                                  <!-- </div> -->
                                </div>
                                <div class="overlay1"></div>
                                <!-- <video height="280" controlsList="nodownload" controls muted  preload="metadata"  loop="loop"   :id="'postvideo'+index"  :ref="'video'+video.id" class="postedvideoItem">
                                  <source :src="video.videoLink" >
                                </video> -->
                                <!-- <span v-if="video.aspectRatio" >
                                  <span v-if="video.aspectRatio < 1">
                                    <video controlsList="nodownload" controls muted :src="video.videoLink" oncontextmenu="return false;" class="postedvideoItem portraitvideheight" @loadedmetadata="videoMetaLoaded(index,video.id)" @error ="videoLoading(video.id,index)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)" :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                                    </video>
                                  </span>
                                  <span v-if="video.aspectRatio >1">
                                    <video controlsList="nodownload" controls muted  :src="video.videoLink" oncontextmenu="return false;" class="postedvideoItem" @loadedmetadata="videoMetaLoaded(index,video.id)" :ref="'video'+video.id"  @error ="videoLoading(video.id,index)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)"  :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                                    </video>
                                  </span>
                                  <span v-if="video.aspectRatio = 1">
                                    <video controlsList="nodownload" controls muted :src="video.videoLink" oncontextmenu="return false;" class="postedvideoItem" :class="{'portraitvideheight' : video.videoHeight > video.videoWidth}" @loadedmetadata="videoMetaLoaded(index,video.id)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)" @error ="videoLoading(video.id,index)" :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                                    </video>
                                  </span>
                                </span>
                                <span v-else> -->
                                  <video controlsList="nodownload" height="430px" :src="video.videoLink" oncontextmenu="return false;" controls muted @loadedmetadata="videoMetaLoaded(index,video.id)" class="postedvideoItem" @error ="videoLoading(video.id,index)" @pause="videoPause(video,index)" v-on:play="videoPlay(video,index)"  :ref="'video'+video.id" :id="'postvideo'+index" preload="metadata" webkit-playsinline playsinline>
                                    <!-- <source :src="video.videoLink"> -->
                                  </video>
                                <!-- </span> -->
                              </div>   
                              <!-- <div class="postvideocontent p-1 pb-2 pl-3 d-flex justify-content-between">
                                <div class="d-flex flex-column pl-2 descript-section">
                                  <span class="proximanova-semibold fontsize16 black80 text-capitalize">{{video.videoTitle}}</span>
                                  <span class="proximanova fontsize14 flex-wrap" v-if="video.description1">{{video.videoDescription}}
                                  <span @click="readmore(index)" v-if="video.videoDescription.length > 299"><span v-if="!video.readmoreclicked" class="proximanova fontsize14 fontsize14 blue pointer">...readmore</span></span><span class="proximanova fontsize14 fontsize14 blue pointer" v-if="video.readmoreclicked" @click="readless(index)">...readless</span>
                                  </span>                          
                                </div>
                                <div @click="saveVideo(video.id, video.profileId)" class="hover" v-if="currentUser.profileId !== video.profileId">
                                  <img src="../assets/save.svg" width="20px" alt="" class="p-1">
                                  <span class="fontsize12 proximanova-bold black mr-3">Save</span>                          
                                </div>
                              </div>  -->
                              <div class="postvideocontent p-1 pb-2 pl-3 d-flex justify-content-between">
                                <div class="d-flex flex-column pl-2 descript-section" >
                                  <span class="proximanova-bold fontsize16 black80 text-capitalize" >{{video.videoTitle}}</span>
                                  <!-- <span class="proximanova fontsize14" v-if="video.userDetailsVo">{{video.userDetailsVo.videoDescription}}</span> -->
                                  
                                  
                                </div>
                                <div class="hover" v-if="currentUser.profileId !== video.profileId">
                                  <span v-if="video.savedVideoFlag === 'Y'" @click="unSaveVideo(video.id, video.profileId, index)">
                                    <img src="../assets/saveblue.svg" width="20px" alt="saved" class="p-1">
                                    <span class="fontsize12 proximanova-bold blue mr-3">Saved</span>
                                  </span>
                                  <span v-else @click="saveVideo(video.id, video.profileId, index)">
                                    <img src="../assets/save.svg" width="20px" alt="saved" class="p-1">
                                    <span class="fontsize12 proximanova-bold black mr-3">Save</span>
                                  </span>                         
                                </div>
                              </div> 
                              <div class="pl-3 pr-3">
                                <div class="ml-2">
                                  <span class="proximanova fontsize14 flex-wrap black60 " v-if="video.sharedescription1">{{video.shareDescription}}<span @click="readmoreshare(index)" v-if=" video.shareDescription && video.shareDescription.length > 149"><span v-if="!video.readshareclicked" class="proximanova fontsize14 fontsize14 blue pointer">...readmore</span></span><span class="proximanova fontsize14 fontsize14 blue pointer" v-if="video.readshareclicked" @click="readlessshare(index)">...readless</span>                  </span>
                                </div>
                                <div class="ml-2">
                                  <span class="proximanova fontsize14 blue" v-if="video.hashTagList && video.hashTagList.length > 0">{{video.hashTagList[0].hashTag.tagText}}</span>
                                </div>
                              </div>
                            </div>
                          </div>             
                        </div>
                        <div class="d-flex p-3 ">
                          <div class="d-flex ml-2 ">
                            <img src="../assets/Like.svg" alt="like" class="postvideoIcons" v-if="video.likeVideoFlag === 'N'" @click="likeVideo(video.id, video.profileId)">
                            <img src="../assets/Likedblue.svg"  alt="like" class="postvideoIcons" v-if="video.likeVideoFlag === 'Y'" @click="unlikeVideo(video.id, video.profileId)">
                            <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="video.noOfLikes>0"><span v-if="video.noOfLikes<10">0</span>{{video.noOfLikes}}</span>
                            <span class="profiledetails  fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                          </div>
                          <div class="d-flex ml-lg-5 ml-4">
                            <img src="../assets/Comment.svg" alt="comment" v-if="video.commentVideoFlag == 'N'" class="postvideoIcons">
                            <img src="../assets/Commentblue.svg" alt="comment" v-if="video.commentVideoFlag == 'Y'" class="postvideoIcons">
                            <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="video.noOfComments>0">{{video.noOfComments}}</span>
                            <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                          </div>
                          <div class="d-flex ml-lg-5 ml-4">
                            <img src="../assets/Share_Video.svg" alt="share" class="postvideoIcons"  @click="ShareVideoModal(video,'shared','create')">
                            <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2 share-text">Share</span>
                          </div>
                          <div class="d-flex ml-lg-5 ml-4">
                            <img src="../assets/Views.svg" alt="views" class="postvideoIcons">
                            <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-if="video.noOfViews>0">{{video.noOfViews}}</span>
                            <span class="profiledetails fontsize12 proximanova  black60 pt-1 ml-2" v-else>00</span>
                          </div>
                        </div>  
                        <div class="horizonline1"></div> 
                        <div class="card-footer"> 
                          <div class="commentsection d-flex pt-3 pl-3 pr-3 pb-1 comment-background">
                            <div class=" pl-2">
                              <!-- <img v-if="!currentUserProfilePic" oncontextmenu="return false;" src="../assets/Profile_placehlder.svg" alt="profilepic" class="img-fluid postvideoimage" width="38px"> -->
                              <div v-if="!currentUserProfilePic" id="profImage" class="othercircles text-center pointer rounded-circle white" :class="currentUser.firstName.charAt(0)" oncontextmenu="return false;">
                                <span class="white fontsize16 defpaddingtop text-uppercase">{{currentUser.firstName.charAt(0)}}</span>
                              </div>
                              <img v-else :src="currentUserProfilePic" oncontextmenu="return false;" alt="profilepic" class="rounded-circle loadingBgImg" width="38px">
                            </div>
                            <div class="commentssection d-flex">
                              <input type="text" v-model="video.comment" class="commentssectiontext proximanova black60" placeholder="Add my comment..." alt="comment" @keyup="video.postcommentbtn = true">
                              <img src="../assets/commentsend.svg" width="30px" v-if="video.postcommentbtn" height="25px" title="post comment"  class="postcommenticon ml-1" alt="comment" @click="PostComment(video.id, video.profileId,video.comment)">
                            </div>                        
                          </div>  
                          <div v-if="video.listOfComments">
                            <div class="pb-3">
                              <div v-if="video.listOfComments.length>0">
                                <div v-for="(comment,cmind) in video.listOfComments" :key="cmind" class="comment-background" >
                                  <div class="d-flex pt-3 pl-3 pr-3" v-if="cmind < video.limit_by">
                                    <div class=" pl-2">
                                      <!-- <img v-if="!comment.profilePictureLink" oncontextmenu="return false;" src="../assets/Profile_placehlder.svg" alt="" class="rounded-circle" width="38px"> -->
                                      <div v-if="!comment.profilePictureLink" id="profImage" class=" text-center pointer rounded-circle white" :class="comment.firstName.charAt(0)" oncontextmenu="return false;">
                                        <p class="white fontsize16 defpaddingtop text-uppercase">{{comment.firstName.charAt(0)}}</p>
                                      </div>
                                      <img v-else :src="comment.profilePictureLink" @error="comment.profilePictureLink = null" oncontextmenu="return false;" alt="profilepic" class="rounded-circle loadingBgImg" width="38px">
                                    </div>
                                    <div v-if="currentUser.profileId !== comment.profileId" class="commentssectiontext2 pl-3 p-2">
                                      <div class="d-flex flex-column">
                                        <span class="fontsize12 proximanova-semibold black">{{comment.firstName}} {{comment.lastName}}</span>
                                        <span class="proximanova black80 fontsize12" v-if="comment.designationName">{{comment.designationName}} <span class="proximanova black80 fontsize12" v-if="comment.country">, {{comment.country}}</span></span>
                                      </div>
                                      <span class="fontsize14 black80 proximanova">{{comment.comment}}</span>
                                    </div>
                                    <div v-else class="commentssectiontext2 pl-3 p-2">
                                      <div class="d-flex justify-content-between">
                                        <div class="d-flex flex-column">
                                          <span class="fontsize12 proximanova-semibold black">{{comment.firstName}} {{comment.lastName}}</span>
                                          <span class="proximanova black80 fontsize12">{{comment.designationName}}, {{comment.country}}</span>
                                        </div>
                                        <div>
                                          <img src="../assets/commentsend.svg" width="28px" height="22px" class="postcommenticon mr-2" v-if="comment.iscommentchanged" title="update comment" alt="sendcomment" @click="Update(comment.commentId,video.id, video.profileId,comment)">
                                          <img src="../assets/Delete_Comment.svg" width="28px" height="22px" class="postcommenticon mt-2 mr-2" title="delete comment" alt="delete" @click="openDeleteCommentConfirmationmodal(cmind, comment, video)">
                                          <!-- <img src="../assets/deletecomment.svg" width="28px" height="22px" class="postcommenticon mt-2 mr-2" title="delete comment" @click="openDeleteCommentConfirmationmodal(cmind, comment, video)">                                         -->
                                        </div>
                                      </div>
                                      <input type="text" class="commentssectiontext3 proximanova black60  fontsize14" v-model="comment.comment">
                                    </div>                                
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="viewallcomments pl-5 pb-3" >
                              <!-- <span class="pl-4 ml-3" v-if="video.noOfComments > 1 && video.noOfComments > video.limit_by"  @click="showAllComments(video.id)">View all Comments</span> -->
                              <span class="pl-4 ml-3 proximanova black fontsize12" v-if="video.noOfComments > 0 && video.noOfComments > video.limit_by"  @click="showAllComments(video.id)">View all Comments</span>
                              <span class="pl-4 ml-3 proximanova black fontsize12" v-if="video.limit_by > 0 && video.noOfComments <= video.limit_by"  @click="viewLessComments(video.id)">View less Comments</span>
                            </div>                          
                          </div>   
                        </div>                         
                      </div>
                    </div>
                </div>
              </div>
              <sharevideomodal  v-if="shareavideomodalopen" :sharevideo="sharevideoobject" @close = "closeshareModal"></sharevideomodal>
              <reportMessageModal  v-if="reportmodalopen" :reportmessage="reportmessagesobject" @closereport = "closereportModal"></reportMessageModal>            
            </div>
          </div>
        </div>
        <div class="col middle-background">
          <div class="row no-gutters">
            <br />
          </div>
          <div class="row row no-gutters">
            <br />
          </div>
          <pendingActivities />
        </div>
      </div>
      <div class="col-12 pb-5  sign-in-navheight" v-if="instanceLoader">
        <img src="../assets/pageloader.svg" class="instanceloader" alt="loading">
      </div>
    </div>
    <!-- <Footer class="footer d-block d-sm-block d-md-block d-lg-none" /> -->
    <hide-confirmation-modal :modalTitle="modalTitle" v-if="hideconfirmationmodalopen" @closeConfirmModal = "CloseHideConfirmationModal"></hide-confirmation-modal>
    <delete-comment-confirmation-modal :modalTitle="deleteCommentTitle" v-if="deletecommentconfirmationmodalopen" @CloseCommentConfirmationModal = "CloseCommentConfirmationModal"></delete-comment-confirmation-modal>
    <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
  </div>
</template>
<script>
import sidemenu from "@/components/SideMenu.vue";
import pendingActivities from "../components/PendingActivities.vue";
import topmenu from "@/components/TopHeader.vue";
import httpuserprofile from "@/js/http-userprofile.js";
import Footer from "../components/Footer";
import moment from 'vue-moment';
import $ from "jquery";
import sharevideomodal from '@/components/SharePostModal.vue';
import reportMessageModal from '@/components/reportMessagesModal.vue';
import NoProfileIdComponent from '../components/NoProfileId.vue'
import NoRecordsFound from '../components/NoRecordsFound.vue'
import HideConfirmationModal from '../components/ConfirmationModal.vue'
import deleteCommentConfirmationModal from '../components/deleteCommentConfirmModal.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import sessionUtils from '@/js/session-util.js'
export default {
    components: {
    sidemenu,
    topmenu,
    pendingActivities,
    Footer,
    sharevideomodal,
    reportMessageModal,
    NoProfileIdComponent,
    NoRecordsFound,
    HideConfirmationModal,
    deleteCommentConfirmationModal,
    APIerrorModal
  },
  data(){
      return {
          homeVideos: [],
          currentUserProfilePic: null,
          duration: null,
          comment: '',
          showComments: false,
          editComment: '',
          commentChanged: false,
          diff: [],        
          showdropdown: false,
          currentUser: [],
          message: '',
          isPlaying: false,
          shareavideomodalopen : false,  
          sharevideoobject : {},
          reportmessagesobject : {},
          reportmodalopen : false,  
          pageloader: true,
          default_limit: 1,
          limit_by: 1,
          editedComment: false,
          readmoreclicked: false,
          isScrolled: false,
          limit: 10,
          homeoffset: 0,
          counter:1,
          showMoreVideos: false,
          reportmessages: [],
          firstVideoId: null,
          gotlatestVideoresponse : true,
          latestRecord: [],
          latestVideoId: null,
          videoDuration: null,
          interval: null,
          videoWatched: false,
          playVideo: [],
          instanceLoader: false,
          reportedVideoIndex : null,
          hideconfirmationmodalopen : false,
          selectedVideoForHide : null,
          selectedVideoIndexForHide : null,
          instanceVidoesListflag : false,
          oneTimeNoMoreVideosMessage : false,
          newVideoInterval : null,
          noRecordsFoundMessage : 'No Videos are present for this profile',
          modalTitle : "Are you sure you want to hide this video ?",
          deletecommentconfirmationmodalopen : false,
          selectedVideotodeletecomment : null,
          selectedcommenttodelete : null,
          selectedcommentIndex : null,
          deleteCommentTitle : "Are you sure you want to delete this comment ?",
          displayAPIerrorModal : false
      }
  },
  methods:{
    closeAPIerrorModal(){
      this.displayAPIerrorModal = false;
    },
    profilePictureFailure(video, type) {
      if(type == 'original') {
        video.userDetailsVo.profilePictureLink = null;
      }else if(type == 'shared'){
        video.sharedVideoUserDetails.profilePictureLink = null
      }
    },
    // initial home feed data rendering
    // modified each video object for other functionalities like moremenu popover, commments view/hide, play/pause functionality, video offset to set dynamic card height
       // and also readmore/readless video description
      getVideos(){      
          this.instanceVidoesListflag = false  
          httpuserprofile
            .get("/userprofile/listOfHomeVideos?profileId="+this.currentUserProfileId+"&limit="+this.limit+"&offset="+this.homeoffset)            
            .then(response => {      
              console.log(response)   
              if(response.data && response.data.length < 1){
                this.oneTimeNoMoreVideosMessage = true;                
              }else{
                this.instanceVidoesListflag = true;
              }  // this.pageloader = false;
                
                 response.data.forEach(function(d,index){
                    d.isPlaying = false;    
                    d.moremenuname = 'popover'+index;           
                    d.comment = '';
                    d.showComments = false;      
                    d.mainVideoDetails = []; 
                    d.readmoreclicked = false;
                    d.readshareclicked = false;
                    d.limit_by = 0;                   
                    d.activate =false;   
                    d.disablefollowBtn = false;    
                    d.postcommentbtn = false;
                    d.reportClicked= false;
                    d.videoDuration = null;
                    d.videoWatched =false;
                    d.videoPaused = false;
                    d.pausefromScroll = false;
                    d.videoWidth = null;
                    d.videoHeight  = null;
                    d.aspectRatio = null;
                    let description = d.videoDescription;
                    if(description){
                      d.description1= description.substr(0,300);
                      d.videoDescription = d.description1;
                      d.description1 = description.substr(0,300);
                      d.description2 = description.substr(300);
                    }
                    if(d.listOfComments && d.listOfComments.length > 0){
                      d.listOfComments.forEach(function(c){
                        c.iscommentchanged = false;
                      })
                    }
                    // console.log("before moment : ", d.creationD)
                    // let creationD = moment().utc(d.creationD)
                    // d.creationD = creationD.local();
                    // console.log("after adding moment : ", d.creationD)
                    if(d.userDetailsVo && d.userDetailsVo.videoDescription){
                      let shareDescription = d.userDetailsVo.videoDescription;
                      if(shareDescription){
                      d.sharedescription1= shareDescription.substr(0,150);
                      d.shareDescription = d.sharedescription1;
                      d.sharedescription1 = shareDescription.substr(0,150);
                      d.sharedescription2 = shareDescription.substr(151);
                    }
                    } 
                })         
                this.homeVideos = this.homeVideos.concat(response.data);  
                console.log(this.homeVideos) 
                if(this.homeVideos.length > 0 && this.homeoffset == 0){             
                  this.firstVideoId = this.homeVideos[0].id; 
                }   
                this.pageloader = false;            
                this.isScrolled = false
                this.showMoreVideos = false;
                this.instanceLoader = false;             
              }).catch((e) => {
              console.log(e)
              this.displayAPIerrorModal = true;
              this.pageloader = false;
              this.isScrolled = true;
              this.instanceLoader = false;
              this.instanceVidoesListflag = false
            })           
      },
      // this will invoke after click close btn moremenu popup
      // close moremenu popover 
      close:function(video, ind){        
        video.reportClicked = false;
        var id =video.moremenuname;
        console.log(id)
        if(id){
          document.getElementById(id).click()
        }
        
    },
    // this will invoke after click on new posts button
    // to refresh home feed content
    getVideosAfter(){
      this.homeVideos = [];
      this.pageloader= true;
      this.getVideos();
    },
    // readmore/readless video description
    readmore(ind){
      this.homeVideos[ind].videoDescription = this.homeVideos[ind].videoDescription.concat(this.homeVideos[ind].description2);
      // this.videoDescription = this.videoDescription.concat(this.aboutYou2)
      this.homeVideos[ind].readmoreclicked = true;

    },
    videoLoading(id,index){
      this.homeVideos[index].videoLink = null;
    },    
    
    readless(ind){
      this.homeVideos[ind].videoDescription = this.homeVideos[ind].videoDescription.substr(0, 400) ;
      this.homeVideos[ind].readmoreclicked = false;
    },
    // this will invoke after click on user profile picture / user name on video card
    // naviaget to seperate page where user can able to see the selected user information
    selectedUser(id){  
      this.$store.state.selectedUser = id;      
      // if(sessionUtils.getUserId() === id){
      //   this.$router.push({
      //     name : 'welcome'
      //   })        
      // }else{
        this.$router.push({name: 'wn', params: { id: this.$store.state.selectedUser}});
      // }  
    },
    // this will invoke after click on delete option on moremenu popover
    DeletePostedVideo : function(video, index) {
      console.log("delete post video id : ", video.id)
      console.log("index : ", index)
      httpuserprofile.delete('/userprofile/deleteSharedVideo?videoId='+video.id)
      .then((response) => {
        console.log(response)
        // this.homeVideos.splice(index, 1)
        this.homeVideos.splice(index,1);
        this.homeVideos.forEach((video,index) =>{
          video.moremenuname = 'popover'+index;
        })
        this.close(video,index)
        // this.getPostedVideos()
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // readmore/readless shared video description
    readmoreshare(ind){
      this.homeVideos[ind].shareDescription = this.homeVideos[ind].shareDescription.concat(this.homeVideos[ind].sharedescription2);
      // this.videoDescription = this.videoDescription.concat(this.aboutYou2)
      this.homeVideos[ind].readshareclicked = true;

    },
    readlessshare(ind){
      this.homeVideos[ind].shareDescription = this.homeVideos[ind].shareDescription.substr(0, 200) ;
      this.homeVideos[ind].readshareclicked = false;

    },
    // this will invoke after click on close btn/ successfully shared any video
    // status will tell us wether the video sucessfully shared or not
    closeshareModal(value) {
      // console.log("hit this method after close", value)
      this.shareavideomodalopen = false;
      if(value === 'SUCCESS') {
        // this.homeVideos = [];
        // this.instanceLoader = false;
        // this.getVideos();
        console.log("successfully shared")
      }
    },
    // not in use
    clickedShowDetailModal : function(value) {
      console.log("getting data : ", value)
    },
    // this will invoke after successfully reported on a video / click cancel button on report modal
    // if video is sucessfully reported clear the video from the feed and set the moremenun popover name again to all the videos
     closereportModal(type){
      this.reportmodalopen = false;
      if(type === 'SUCCESS') {
        if(this.reportedVideoIndex) {
          this.homeVideos.splice(this.reportedVideoIndex,1);
          this.homeVideos.forEach((video,index) =>{
            video.moremenuname = 'popover'+index;
          })
        }
        console.log("reported and deleted")
        this.reportedVideoIndex = null
        // this.homeVideos = [];
        // this.instanceLoader = false;
        // this.getVideos(); 
      }else{
        console.log("notsuccess ", type)
        this.reportedVideoIndex = null
      }
         
    },
    // this will invoke aftre click on share option on moremenu popover
     ShareVideoModal(item,sectionType,operationType) {          
      item.currentUserProfilepic = this.currentUser.profilePictureLink;
      item.currentUserFirstname = this.currentUser.firstName;
      item.currentUserLastname = this.currentUser.lastName;
      item.currentUserDesignation = this.currentUser.designation.roleName;
      // item.videoUserId = item.profileId;
      if(sectionType === 'posted') {
        item.videoUserId = item.profileId;       
      }else{
        item.videoUserId = item.userDetailsVo.profileId;        
      }
      item.videoUserFirstName = item.userDetailsVo.userFirstName;
      item.videoUserLastName = item.userDetailsVo.userLastname;
      item.videoUserProfilePic = item.userDetailsVo.profilePictureLink;
      item.videoUserDesignation = item.userDetailsVo.designation;      
      item.operationType = operationType;
      this.sharevideoobject = item;
      this.shareavideomodalopen = true;
    },  
    // this wil invoke after video is playing
    // if the video is reached half of its duration make a call (view video) to increase views count of video
    videoPlay(videoitem,index){
      var video = document.getElementById("postvideo"+index);      
      videoitem.videoDuration = video.duration;
      videoitem.videoPaused = false;
      videoitem.pausefromScroll = false;
      var currentTime = videoitem.videoDuration * (50/100);     
      var slef= this                         
      video.ontimeupdate = function(){
        if(currentTime < video.currentTime && !videoitem.videoWatched){      
          videoitem.videoWatched = true;                 
            slef.viewVideo(videoitem);
        }        
      };
      video.onended = function() {
        console.log("after ended")
        var nextIndex = index + 1;
        var nextVideo = document.getElementById("videoCardItem"+nextIndex);
        if(nextVideo) {
          nextVideo.scrollIntoView()
        }
      }
    },
    // this will invoke while loading video meta data
    // set the aspect ratio
    // set dynamic card for different videos based on aspect ratio
    videoMetaLoaded(index,vid){
      var videoElement = document.getElementById("postvideo"+index); 
      if(this.homeVideos[index].aspectRatio === null && vid === this.homeVideos[index].id && videoElement ){        
        this.homeVideos[index].videoWidth = videoElement.videoWidth;
      this.homeVideos[index].videoHeight = videoElement.videoHeight;
      this.homeVideos[index].aspectRatio = videoElement.videoWidth/videoElement.videoHeight;      
      }      
      this.homeVideos[index].pausefromScroll = true;
    },
    // this will invoke after pause any video
    videoPause(videoitem,index){
      var video = document.getElementById("postvideo"+index);
      if(!videoitem.pausefromScroll){        
        videoitem.videoPaused = true;
      }      
    },
    // this will invoke when user view any video morethan a half of its original duartion
    viewVideo: function(video){
    if(video.viewVideoFlag === 'N' && this.currentUserProfileId !== video.profileId){   
      var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        videoId: video.id,
        videoProfileId: video.profileId,
        viewed_sec : 0,
        video_type : 'POSTVIDEO',
        video_duration : 1
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoViews", blob)
      fd.append("duration", 1)
      httpuserprofile.post("/userprofile/viewVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      })
      .then(response => {   
        if(response.data.errorCode === 1030){
          video.videoWatched = false
          video.isPlaying = true;
          video.viewVideoFlag = 'Y';
          video.noOfViews = video.noOfViews+1;
        }                           
      }) .catch((e) => {
        console.log(e)
      })       
    }
  },
  // this will invoke after change the video visibility on moremenu popover
  // update homefeed after update the video visibility
    onChange(eve,video,value){
      httpuserprofile
        .put('/userprofile/updateVideoVisibility?videoId='+video.id+'&visibility='+value)
        .then(response => {
        if(response.data){
          // this.close(video)
          this.getVideos();
        }    
       }).catch((e) => {
        console.log(e)
      })    
    },
    // this is on keyup event to display update button to update the comment
    DisplayPostCommentUpdate : function(comment){
      comment.iscommentchanged = true;
    },
    // not in use
      openDropDown(id){
          this.showdropdown = true;
      },
      //get current user information
      getUserByID(){
        this.currentUserId =sessionUtils.getUserId();
        httpuserprofile
        .get("/userprofile/userbyid/" + this.currentUserId)
        .then(response => {
          response.data['isPlaying'] = false;
             this.currentUserProfileId = response.data.profileId; 
            this.currentUser = response.data;
            this.currentUserProfilePic = response.data.profilePictureLink; 
            if(this.currentUserProfileId) {
            this.getVideos();
            }else{
              this.pageloader = false;
            }
        }).catch((e) => {
        console.log(e)
      })
    },
    // this will invoke after click on report option on moremenu popover
    // open a modal component to where user can report a video
     getReportmessage(item,index){
       this.reportedVideoIndex = index
       console.log('enter here reportindex : ', index)
       this.reportmodalopen = true;         
        item.currentuserId = this.currentUserProfileId;
        this.reportmessagesobject = item;  
    }, 
    // this will invoke after click on hide video option on moremenu popover
    // remove the video from home feed after successfully hided
    openHideConfirmationmodal(video, index) {
      this.hideconfirmationmodalopen = true;
      this.selectedVideoForHide = video,
      this.selectedVideoIndexForHide = index
    },
    CloseHideConfirmationModal(hidestatus){
      if(hidestatus == 'SUCCESS'){
        console.log("api call to hide video", this.selectedVideoForHide)
        this.hideconfirmationmodalopen = false;
        this.hideVideo(this.selectedVideoForHide, this.selectedVideoIndexForHide)
      }else{
        console.log("cancel hide")
        this.hideconfirmationmodalopen = false;
        this.selectedVideoForHide = null;
        this.selectedVideoIndexForHide = null;
      }
    },
    hideVideo(video,index){
        var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        videoId: video.id,
        videoProfileId: video.profileId
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoHide", blob)
      httpuserprofile.post("/userprofile/hidePostedVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log("hide a video : ", response)
          if(response.data){           
            // video.moremenuname = 'popover'+index1;
            this.close(video,index)
            this.homeVideos.splice(index,1);
            this.homeVideos.forEach((video,index) =>{
              video.moremenuname = 'popover'+index;
          })
            
            // this.getVideos();
          }
       }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
      //  this.close();
    },
    // this will invoke after click on unfollow button to unfollow any user
    UnfollowUser(followId,video){
      video.disablefollowBtn = true;
      httpuserprofile
        .delete("/userprofile/unfollow?profileId="+this.currentUserProfileId+"&followingId="+followId)
        .then(response => {
          if(response.data){
            video.followVideoFlag = 'N';
            video.disablefollowBtn = false;
            // this.getVideos();
            this.setFollowFlags('N', followId)
          }          
        }).catch((e) => {
        console.log(e)
        video.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      }); 

    },
    // this will invoke after click on follow button to follow any user
    follow(followId,video){
      video.disablefollowBtn = true;
        this.isScrolled = true;  
        httpuserprofile
            .post("/userprofile/saveFollowing?profileId="+this.currentUserProfileId+"&followingId="+followId)
            .then(response => {
            if(response.data){
              video.followVideoFlag = 'Y';
              video.disablefollowBtn = false;
              //this.getVideos();
              this.setFollowFlags('Y', followId)
          }                
        }).catch((e) => {
        console.log(e)
        video.disablefollowBtn = false;
        this.displayAPIerrorModal = true;
      }); 
        
    },
    setFollowFlags(flagType, followId) {
      console.log("into follow flags setting")
      for(var i =0; i < this.homeVideos.length; i++) {
        if(this.homeVideos[i].profileId == followId) {
          this.homeVideos[i].followVideoFlag = flagType;
        }
      }
    },
    openDeleteCommentConfirmationmodal(cmind, comment, videoItem) {
      this.deletecommentconfirmationmodalopen = true;
      this.selectedcommentIndex = cmind;
      this.selectedcommenttodelete = comment;
      this.selectedVideotodeletecomment = videoItem;
    },
    CloseCommentConfirmationModal(deletecommentstatus) {
      console.log("check status 1")
      if(deletecommentstatus == 'SUCCESS'){
        console.log("api call to delete comment video", this.selectedcommentIndex)
        this.deletecommentconfirmationmodalopen = false;
        this.deletepostedVideoComment(this.selectedcommentIndex, this.selectedcommenttodelete, this.selectedVideotodeletecomment)
      }else{
        console.log("cancel delete comment")
        this.deletecommentconfirmationmodalopen = false;
        this.selectedcommentIndex = null;
        this.selectedcommenttodelete = null;
        this.selectedVideotodeletecomment = null;
      }
    },
    // this will invoke after click on delete button on a comment to remove the comment
    deletepostedVideoComment : function(cmind, comment, videoItem) {
      httpuserprofile.delete("/userprofile/deleteCommentOnVideo?commentId="+comment.commentId)
      .then((response) => {
          console.log("delete response : ", response)
          videoItem.listOfComments.splice(cmind, 1)
          videoItem.noOfComments = videoItem.noOfComments-1;
          // videoItem.commentVideoFlag = 'N';
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    //not in use
    // reportVideo(vid,vprofileId){
    //     var fd = new FormData(); 
    //     var obj = {
    //     profileId : this.currentUserProfileId,
    //     videoId: vid,
    //     reportMessageId: vprofileId
    //   }
    //   var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
    //   fd.append("userVideoReport", blob)
    //   httpuserprofile.post("/userprofile/reportVideo", fd, {
    //     headers: {
    //          "Content-Type": "multipart/form-data",
    //       "Accept" : "*/*"
    //     }
    //   }).then((response) => {
    //     if(response.data){
    //       this.getVideos();
    //     }    
    //    }).catch((e) => {
    //     console.log(e)
    //   })
    //   //  this.close();
    // },
    // this will invoke after click on like button
    likeVideo(vid,vprofileId){        
        var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        videoId: vid,
        videoProfileId: vprofileId
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoLikes", blob)
      httpuserprofile.post("/userprofile/likeVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        var obj={
          firstName : this.currentUser.firstName,
          lastName  : this.currentUser.lastName,
          profileId : this.currentUser.profileId,
          profilePictureLink: this.currentUser.profilePictureLink
        }
          this.homeVideos.forEach(function(video){
            if(vid === video.id){
              video.likeVideoFlag = 'Y';
              video.listOfLikes.push(obj);
              video.noOfLikes = video.noOfLikes+1;
            }
            
          })
       }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // this will invoke after click on view more comments options in comments section if video has more comments
    showAllComments(vid){      
     this.homeVideos.forEach((video) => {      
            if(vid === video.id){
              video.showComments= true;
              video.limit_by = video.limit_by+3;              
            }
     });
    },
    // this will invoke after click on view less comments to hide the comments
    viewLessComments(vid){
      this.homeVideos.forEach((video) => {      
            if(vid === video.id){
              video.showComments= false;
              video.limit_by = 0;              
            }
     });
    },
    // this will invoke after click on unlike button
    unlikeVideo(vid){             
       httpuserprofile
        .delete('/userprofile/unLikesVideo?videoId='+vid+'&profileId='+this.currentUserProfileId)
        .then(response => {
            this.homeVideos.forEach((video) => {
            if(vid === video.id){
              video.likeVideoFlag = 'N';              
              video.noOfLikes = video.noOfLikes-1;
              for(var i=0; i< video.listOfLikes.length; i++){
                if(video.listOfLikes[i].profileId === this.currentUser.profileId){                  
                  video.listOfLikes.splice(i,1);
                }                
              }
            }        
          })
        }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },   
    // this will invoke aftre click on update comment button to update the comment 
    Update(commentId,vid,vprofileId,comment){            
        var fd = new FormData(); 
        var obj = {
        id:commentId,
        profileId : this.currentUserProfileId,
        videoId: vid,
        videoProfileId: vprofileId,
        comments: comment.comment
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoComments", blob)
      httpuserprofile.put("/userprofile/updateComment", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          this.getVideos();
          comment.iscommentchanged = false;
       }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // not in use
    shareVideo(vid,vprofileId){        
        var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        oldVideoId: vid,
        oldVideoProfileId: vprofileId
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoShare", blob)
      httpuserprofile.post("/userprofile/shareVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          this.getVideos();
       }).catch((e) => {
        console.log(e)
      })

    },
    // this will invoke after click on save button on any video to save the video
    saveVideo(vid,vprofileId, index){
        var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        videoId: vid,
        videoProfileId: vprofileId,
        comments: this.comment
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoSave", blob)
      httpuserprofile.post("/userprofile/saveVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
        console.log(response)
        this.homeVideos[index].savedVideoFlag = 'Y'
        this.$toast.success("video saved successfully")
       }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // this will invoke after click on unsave button
    unSaveVideo(vid,vprofileId, index){
      httpuserprofile.delete('/userprofile/unSaveVideo?videoId='+vid+'&profileId='+this.currentUserProfileId)
      .then((response) => {
        console.log(response)
        this.homeVideos[index].savedVideoFlag = 'N'
        this.$toast.success("video unsaved successfully")
      }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // this will invoke after click on post a commment button to add a new comment
    PostComment(vid,vprofileId,vcomment){      
        var fd = new FormData(); 
        var obj = {
        profileId : this.currentUserProfileId,
        videoId: vid,
        videoProfileId: vprofileId,
        comments: vcomment
      }
      var blob = new Blob([JSON.stringify(obj)], { type: "application/json" })
      fd.append("userVideoComments", blob)
      httpuserprofile.post("/userprofile/commentOnVideo", fd, {
        headers: {
             "Content-Type": "multipart/form-data",
          "Accept" : "*/*"
        }
      }).then((response) => {
          if(response.data){         
            this.homeVideos.forEach((video) => {
            if(vid === video.id){
              video.listOfComments = [];              
              for(var i=0; i< response.data.listOfComments.length;i++){
                video.listOfComments = response.data.listOfComments;
              }
              video.noOfComments = response.data.listOfComments.length;
              video.comment = '';            
              video.postcommentbtn = false
              video.commentVideoFlag = 'Y';
            }        
          })          
          }
       }).catch((e) => {
        console.log(e)
        this.displayAPIerrorModal = true;
      })
    },
    // this will invoke while scrolling down to get more records
    // autoplay functionality
     handleScroll () {        
      if(!this.isScrolled){
        this.instanceLoader = false;
        if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown) {
          // this.pageloader = true;
          if(this.instanceVidoesListflag) {
            this.isScrolled = true;  
            this.instanceLoader = true;  
            this.homeoffset = this.homeoffset+10; 
            this.getVideos();
          }else{
            if(this.oneTimeNoMoreVideosMessage){
              this.$toast.success("No More Video Found")
              this.oneTimeNoMoreVideosMessage = false;
            }

          }
        }        
      }     
            var media = $('video').not("[autoplay='autoplay']");
            // console.log(media)
            var playPromise ;
            var tolerancePixel = 250;
            var self=this;
             var scrollTop = $(window).scrollTop() + tolerancePixel;
                var scrollBottom = $(window).scrollTop() + $(window).height() - tolerancePixel;               

                media.each(function(index, el) {
                    var yTopMedia = $(this).offset().top;
                    var yBottomMedia = $(this).height() + yTopMedia;  
                    this.playVideo = $(this).get(0);
                        var vid = this.playVideo.id;
                        var vindex = vid.substr(9) ;
                        // console.log()
                    if(scrollTop < yBottomMedia && scrollBottom > yTopMedia){ //view explaination in `In brief` section above 
                        if(!self.homeVideos[vindex].videoPaused){
                          self.homeVideos[vindex].pausefromScroll = false;
                          if($(this).get(0).hasAttribute('preload') && self.homeVideos[vindex].videoLink !== null){
                            playPromise = $(this).get(0).play(); 
                          }
                          
                        }                 
                        if(playPromise !== undefined && self.homeVideos[vindex].videoLink !== null){
                          playPromise.then(_ => {
                            $(this).get(0).play();          
                          })
                          .catch(error => {
                            // console.log(error)
                          });
                        }                       
                    } else {
                      self.homeVideos[vindex].pausefromScroll = true;
                      if(self.homeVideos[vindex].videoLink !== null){
                        $(this).get(0).pause();
                      }                                               
                    }                                      
                });

  },    

    addbutton(){
      this.homeoffset = 0;
      this.showMoreVideos = true;
    },
    getLatestVideo(){
      httpuserprofile
        .get("/userprofile/listOfHomeVideos?profileId="+this.currentUserProfileId+"&limit="+1+"&offset="+0)            
        .then(response => {
          this.latestRecord = response.data;
          if(this.homeVideos.length > 0 ){
          this.latestVideoId = this.latestRecord[0].id;
          this.gotlatestVideoresponse = true;
          if(this.latestVideoId > this.firstVideoId){
            this.addbutton();
          }
          }
        }).catch((e) => {
          this.gotlatestVideoresponse = false;
        })
    }    
  },
  created(){              
      // this.handleScroll();
      this.isScrolled = true;
      window.scrollTo(0, 0);
      this.currentUserProfileId = sessionUtils.getUserProfileId();
      this.homeoffset = 0;
       window.addEventListener('scroll', this.handleScroll);
        this.getUserByID();
      if(!this.currentUserProfileId){
        this.pageloader = false;
      }
    },
    mounted(){
      // document.body.style.scale = "100%";
      if(this.currentUserProfileId) {
      this.newVideoInterval =  window.setInterval(() => {
        if(this.gotlatestVideoresponse){
          this.gotlatestVideoresponse = false;
         this.getLatestVideo();        
        }
       }, 45000);
      }
    },    
    destroyed() {      
        window.removeEventListener('scroll', this.handleScroll);
        window.clearInterval(this.newVideoInterval)
  }
}

</script>
<style scoped>
html,
body,
.grid {
   height: 100%;
  width: 100%;
    /* margin: -.89px; */
}
.nameBlock:hover{
color:#007AFF;
cursor: pointer;
}
.homevideoslist{
  padding: 0 !important;
}
.pageloader {
  width: 20%;
  margin-top: 25%;
  margin-left: 40%;
}
.more-video{
  position: fixed;
  margin-top: 20px;
  z-index: 2;
  border-color: #f8f9fa;
}
.portraitvideheight{
  height: 500px;
}
.share-text{
  width: 50px;
}
.dropdown-position-bottom.postvideomenu {
    z-index: 3 !important;
    color: rgba(31,31,31,1)  !important;
    font-size: 12px !important;
    top: 50px !important;
    font-weight: 500;
    width: 270px !important;
    top: 7% !important;
    left: unset !important;
    /* left: 0px !important; */
    position: absolute;
    transform: translate3d(-86%, 0%, 0px)  !important;
  }
  .vue-popover.dropdown-position-bottom.postvideomenu:before {
    display: none !important;
  }
  .descript-section{
    width: 80%;
  }
  .commentImg{
    width: 25px;
    height: 25px;
  }
  .postvideoIcons {
  cursor: pointer;
}
input[type="radio"]:checked+label { font-weight: bold; }
input:checked ~ span {
    /* border-color: black; */
    font-weight: bold;
}

.viewallcomments {
  color: black;
  font-size: 12px;
  cursor: pointer;
}
.horizonline{
  margin-left: 20px;
  margin-right: 20px;
  border-bottom: 1px solid #E9EBF0;
}
.readmore {
  cursor: pointer;
  color: #0078FF;
}
#follow{
	transition : ease-out 0.3s;
	POSITION : relative;
	z-index : 1;
  text-align: right;  
  margin-top: -4px;
  /* padding-left : 5px; */
  /* padding-top: 2px; */
  /* margin-top: 10px; */
  /* padding-right: 5px; */
  /* padding-bottom: 2px; */
}
.instanceloader{
  width: 7%;
  margin-top: 2%;
  margin-left: 48%;
}
 #follow:hover{
    cursor: pointer;    
  }
  #follow::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 10%;
	right : 10%;
	bottom : 0;
	opacity : 0;
	content : "";
  border-radius: 20px !important;
	background-color :  rgba(31,31,31,.3);
  }
  #follow:hover:before {
    cursor: pointer;
	transition : 0.5s all ease;
	left : 0;
	right : 0;
  padding-left:5px;
	opacity : 1;
	z-index : -1;
  padding-bottom: 5px;    
  padding-right: 5px !important;
  padding-top: 5px !important;
  border-radius:4px;
  }
.horizonline1{
  border-bottom: 1px solid #E9EBF0;
}
.playpostvideo {
  margin-left: 45%;
  margin-top: 15%;
  cursor: pointer;
}
.commentssection{
  width: 85%;
}
.commentssectiontext2{
  width: 80%;
  padding: 4px;
  padding-left: 12px;
  margin-left: 3%;
  border-radius: 0 15px 15px 15px;
  /* background-color: #F0F2F5; */
}
.commentssectiontext3{
 background-color: #f8f8f9 !important;
}
.postcommenticon{
  margin-right: -5px;
  margin-top: 8px;
  cursor: pointer;
}
.commentssectiontext1{
  width: 70%;
  /* margin-left: 12% !important; */
  padding: 4px;
  padding-left: 8px;
  margin-left: 4%;
  margin-top: 2px;
  border-radius: 15px;
  border: none;
  background-color: #F0F2F5;
  color: rgba(31, 31, 31, .6);
}
.commentssectiontext1:focus{
  outline: none;
  box-shadow: none;
}
.commentssection1{
      border-radius: 0 10px 10px 10px;
    background-color: #F0F2F5;
    /* width: 552px; */
    margin-left: 1%;
}
.commentField{
  width : 60%;
  border: 1px salmon;
}
.description-text{
  width: 80%;
}
.postvideoimage{
  width:45px;
  height: 45px;
  
  /* background: transparent url('http://thinkfuture.com/wp-content/uploads/2013/10/loading_spinner.gif') center no-repeat; */
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.card-footer{
  background-color: rgb(248,248,249);
    padding: 0rem 0rem;
    border-radius: 0px 0px 10px 10px !important;
}
.commentssectiontext1:focus{
  outline: none;
  box-shadow: none;
}
#videoProfile.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.action {
  cursor: pointer;
}
.action:hover {
  background-color:rgba(221, 223, 229,0.4);
  border-radius: 5px;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}

.font14bold {
	  font-weight: bold;
  }
.closebtnmouseover {
  margin-left: 3px;
    margin-bottom: 3px;
    padding-top: 2px;
    padding-left: 2px;
    padding-right: 2px;
    border: 1px solid white;    
}
.closebtnmouseover:hover {
  /* margin-top: -4px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  padding-left: 6px;
  padding-right: 3px; */
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.closebtn {
  cursor: pointer;
  width: 13px;
  height: 15px;
  /* margin-top: -3px; */
  margin-left: 4px;
  margin-bottom: 3px;
}
.sign-in-button{
  background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
	opacity: 90% !important;
	color: #FFFFFF !important;
  border-color: #f8f9fa;
}
.sign-in-button::before {
	transition : 0.5s all ease;
	position : absolute;
	top : 0;
	left : 30%;
	right : 30%;
	bottom : 0;
	opacity : 0;
	content : "";
	background-color :  rgba(255,255,255,.3);
  }
  .sign-in-button:hover:before {
	transition : 0.5s all ease;
	left : 0;
	right : 0;
	opacity : 1;
	z-index : -1;
  border-color: #f8f9fa;
  }
  .btn-secondary{
    border-color: #f8f9fa;
  }
.more-button{
  width: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
}
/* .closebtnmouseover:hover {
  margin-top: -4px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  padding-left: 6px;
  padding-right: 3px;
  border: 1px solid rgba(161, 166, 179,.5);
} */
.pausebtn1{
  display: none;
  margin-left: 45%;
  margin-top: 17%;
  cursor: pointer;
}
.overlay:hover .pausebtn1{
  display: block !important;
}
.input-create {
  font-size: 14px;
  padding: 5px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
.label-create {
  color: #999;
  font-size: 14px;
  font-weight: normal;
  position: absolute;
  pointer-events: none;
  left: 5px;
  top: 10px;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.input-create:focus{
  outline: none; /** For Safari, etc **/
  border: transparent;
}
/* active state */
.input-create:focus ~ .label-create,
.input-create:valid ~ .label-create {
  top: -20px;
  font-size: 14px;
  /* color: #0078FF; */
}
#TextField{
  width: 100%;
}

#commentImage{
  padding-top: 1%;
   
}
#commentImage img{
width: 40px;
  height: 40px;
}

.card-header {
  padding: 5px 10px 5px 10px;
  margin-bottom: 0;
  border: 1px solid #d9dce1;
  opacity: 0.6;
  border-radius: 8px;
  background-color: #f0f2f5;
}
.no-padding{
  padding-bottom: 0rem  !important;
    padding-top: 0rem !important;
}
.hover{
    cursor: pointer;
}
.comment-background{
  background-color: rgb(248,248,249);
}
.videocardbody {
    position: relative;
    width: 100%;
    height: 100%;
    background-attachment: scroll;
    overflow: hidden;
    z-index: 0;
}
.videocardbody video {
  background-color: #1F1F1F;
    min-width: 100%;
    width: 100%;
    min-height: 100%;
    position: relative;
    z-index: 1;
    /* object-fit: fill; */
}
.videocardbody .overlay {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 2;
    background: rgba(31, 31, 31, .6);
    /* background: linear-gradient(0deg, rgba(0,0,0,0) 0%, #000000 100%); */
    /* background: linear-gradient(180deg, rgba(0,0,0,0) 0%, #000000 50%); */
    opacity: 0.5;
    margin-top: -5px;
}
#filterDropdown{
 top: 10%;
 left : 67%;
 z-index: 5;
 border: 1px solid;
 border-color: #DDDFE5;
}
.dropdown-menu{
    display:block;    
    color: black;
    box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
    border: none;
    /* min-width:100%; */
    margin-top: 0px;   
    border-radius: 10px  !important;
}
.footer {
  position: fixed;
  z-index:5;
  bottom: 0;
}
.form-control:focus{
  outline: none !important;
    box-shadow: none !important;   
    background-color: #F0F2F5;
    border-radius: 20px; 
}
#commentField {
    border: none;
    background-color: #F0F2F5;
    border-radius: 20px;
}
#commentField:focus,
textarea:focus {
  outline: none; /** For Safari, etc **/
  border: transparent;
  /* text-decoration: underline; */
}

#postedvideoItem{
  width: 100%;
  border: 1px solid #1F1F1F;
}
#playvideobtn {
  position: absolute;
    top: 0;
  /* display: block;
  margin-left: 45%; */
  margin-top: 35%;
  /* margin-bottom: 5%; */
  cursor: pointer;
}

.pausebtn {
  
  position: absolute;
    top: 0;  
  margin-top: 35%;
 
  cursor: pointer;
}

.list-group-item {
  position: relative;
    display: block;
    padding: 0.5rem 0.25rem;
    background-color: #fff;
    border: none;
    margin-left: -10%;
    /* opacity: 60% */
}
.header {
  position: fixed;
  width: 100%;
  z-index: 10;
  background: #ffffff;
  border-bottom: 2px solid rgba(219, 219, 219,1);
}
.nameblock {
  padding-left: 0 !important;
}
p {
    margin-left: 8% !important;
}

.header__content-text {
  text-align: center;
  padding: 15px 20px;
}
.menuicon {
  cursor: pointer;
  /* padding-top: 1px; */
}
.moreactionsmenu{
  width: 22px;
  height: 22px;
  padding: 3px;
}
.moreactionsmenu:hover{
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 50%;
  width: 22px;
  height: 22px;
  padding: 3px;
  border: 1px solid rgba(161, 166, 179,.5);
}


.line {
  display: block;
  height: 1px;
  border: 0;
  padding: 0;
  border: 1px solid #1f1f1f;
  opacity: 0.1;
}
.othercircles {
    /* color: white;
    width: 40px !important;
    height: 40px !important; */
    line-height: 40px !important;
    text-align: center;
}
#profImage{
  width: 40px;
  height: 40px;
}
a{
    color: #1F1F1F;
}
@media screen and (min-width: 800px){
  .pageloader {
    width: 7%;
  margin-top: 15%;
  margin-left: 46%;
}
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
  .pageloader {
    width: 7%;
    margin-top: 15%;
    margin-left: 46%;
  }
}
@media screen and (max-width: 768px) and (min-width: 400px) {
  .commentssection1{
      
    width: 400px !important;
    margin-left: 1%;
}
}
@media screen and (max-width: 539px) and (min-width: 400px) { 
  .playpostvideo {   
    margin-top: 30%;    
   }
   .pausebtn1{
      margin-top: 32%; 
   }
}
@media screen and (max-width: 600px) {
  .share-text{
  width: 35px;
}
  .videocardbody video {
    width: 100%  !important;
  }
  .descript-section{
    width: 70%;
  }
}

/* @media screen and (max-width: 900px) and (min-width: 769px) {
  .dropdown-position-bottom.postvideomenu {
    left : 61.5%  !important;
  }
} */
@media only screen and (max-width: 400px) {   
  .playpostvideo {   
    margin-top: 30%;    
    
   }
   .pausebtn1{
     margin-top: 32%;
   }
  .no-video {
    width: 50%;
    align-self: center;
  }
  #commentImage{
  width: 40px;
  height: 40px;
}
     .topmenubar {
    margin-left: 1.5em;
  }
}
</style>
